<template>
  <div class="content statistiques-page">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <CardStat />
      </transition>

      <div class="dashboard">
        <transition name="fade" mode="out-in">
          <ChartBar />
        </transition>
        <transition name="fade" mode="out-in">
          <CamenBert />
        </transition>
      </div>

      <!-- Formulaire de reporting -->
      <div v-if="userRole === 'admin' || userRole === 'employe'" class="reporting-form mt-4">
        <div class="cardi">
          <div class="card-header">
            <h5><i class="fas fa-file-alt me-2"></i>Reporting form-actions</h5>
          </div>
          <div class="card-body">
            <form @submit.prevent="generateReport" class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Client</label>
                <select v-model="selectedClient" class="form-select" required>
                  <option :value="null">Sélectionnez un client</option>
                  <option v-for="client in clients" :key="client.login || client.email" :value="client.login">
                    {{ [client.prenom, client.nom].filter(Boolean).join(' ') || client.login || client.email }}
                  </option>
                </select>
              </div>

              <div class="col-md-3">
                <label class="form-label">Date début</label>
                <input v-model="startDate" type="date" class="form-control" required>
              </div>

              <div class="col-md-3">
                <label class="form-label">Date fin</label>
                <input v-model="endDate" type="date" class="form-control" required>
              </div>


              <div class="col-md-2 d-flex align-items-end">
                <button type="submit" class="btn btn-primary w-100" :disabled="loading || !selectedClient || !startDate || !endDate">
                  <i v-if="!loading" class="fas fa-search me-2"></i>
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  {{ loading ? ' ' : 'Générer' }}
                </button>
              </div>
            </form>


            <!-- Résultats du rapport -->
            <div id="pdf-content">
              <div v-if="reportData && reportData.length > 0" class="mt-4">
                <div class="d-flex justify-content-end mb-3">
                  <button @click="exportPDF" class="btn btn-sm btn-outline-danger me-2">
                    <i class="fas fa-file-pdf"></i> PDF
                  </button>
                </div>

                <!-- Affichage des recommandations -->
                <div v-for="(recommendation) in reportData" :key="recommendation.id" class="mb-5">
                  <!-- En-tête de la recommandation -->
                  <div class="recommendation-header mb-3 rounded">
                    <h5 class="mb-1"><strong>Titre : </strong>{{ recommendation.titre }}</h5>
                    <p><strong>Description : </strong>{{ recommendation.description }}</p>
                    <div class="text-muted">
                      <span class="me-3"><i class="fas fa-calendar-alt me-1"></i> Date de création: {{
                        formatDate(recommendation.date_creation) }}</span>
                      <span class="me-3"><i class="fas fa-calendar-alt me-1"></i> Date d'échéance: {{
                        formatDate(recommendation.date_echeance) }}</span>
                      <span><i class="fas fa-info-circle me-1"></i> Statut global:
                        <span>
                          {{ recommendation.statut }}
                        </span>
                      </span>
                    </div>
                  </div>

                  <!-- Tableau Client -->
                  <div class="mb-4">
                    <h6 class="mb-2">Actions du client {{ recommendation.clientDisplay }}</h6>
                    <div class="table-responsive">
                      <table class="table table-sm table-bordered">
                        <thead class="table-light">
                          <tr>
                            <th>Action</th>
                            <th>Date</th>
                            <th>Statut</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="action in recommendation.clientActions" :key="action.id">
                            <td>{{ action.description }}</td>
                            <td>{{ formatDate(action.date) }}</td>
                            <td>
                              <span>
                                {{ action.statut }}
                              </span>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Tableau Conseillé -->
                  <div>
                    <h6 class="mb-2">Actions de GWEM</h6>
                    <div class="table-responsive">
                      <table class="table table-sm table-bordered">
                        <thead class="table-light">
                          <tr>
                            <th>Action</th>
                            <th>Date</th>
                            <th>Statut</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="action in recommendation.advisorActions" :key="action.id">
                            <td>{{ action.description }}</td>
                            <td>{{ formatDate(action.date) }}</td>
                            <td>
                              <span>{{ action.statut }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="table table-sm table-bordered">
                        <thead class="table-light">
                          <tr>
                            <th> </th>
                            <th>Responsable</th>
                            <th>Informed</th>
                            <th>Accountable</th>
                            <th>Consulted</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="action in recommendation.advisorActions" :key="action.id">
                            <td>Personne en charge</td>
                            <td>{{ formatEmployeName(action.responsible || action.responsable) }}</td>
                            <td>{{ Array.isArray(action.informed) ? action.informed.map(emp => `${emp.prenom} ${emp.nom}`).join(', ') : (action.informed ? `${action.informed.prenom} ${action.informed.nom}` : '') }}</td>
                            <td>{{ Array.isArray(action.accountable) ? action.accountable.map(emp => `${emp.prenom} ${emp.nom}`).join(', ') : (action.accountable ? `${action.accountable.prenom} ${action.accountable.nom}` : '') }}</td>
                            <td>{{ Array.isArray(action.consulted) ? action.consulted.map(emp => `${emp.prenom} ${emp.nom}`).join(', ') : (action.consulted ? `${action.consulted.prenom} ${action.consulted.nom}` : '') }}</td>
                            
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="reportData && reportData.length == 0" class="text-center mt-4 text-muted">
                <i class="fas fa-file-alt fa-2x mb-2"></i>
                <p>Aucune recommandation trouvée pour cette période.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import CardStat from '@/components/mandat/CardStat.vue';
import ChartBar from '@/components/mandat/ChartBar.vue';
import CamenBert from '@/components/mandat/CamenBert.vue';
import Swal from 'sweetalert2';

import { getUserRole, refreshProfileFromApi } from '@/utils/auth';
import { isAuthenticatedSession } from '@/utils/sessionAuth';

export default {
  components: {
    CardStat,
    ChartBar,
    CamenBert
  },
  data() {
    return {
      clients: [],
      selectedClient: null,
      reportData: [],
      errorMessage: null,
      loading: false,
      startDate: null,
      endDate: null,
      profileRevision: 0,
    };
  },
  async created() {
    await refreshProfileFromApi();
    this.profileRevision += 1;
    this.fetchClients();
  },
  computed: {
    userRole() {
      void this.profileRevision;
      return getUserRole() || '';
    },
  },
  methods: {
    async fetchClients() {
      try {
        if (!isAuthenticatedSession()) {
          this.$router.push('/connexion');
          return;
        }

        const response = await axios.get("/api/clients-private/", {
        });

        const raw = Array.isArray(response.data) ? response.data : (response.data?.results || response.data?.data || []);
        this.clients = raw;
      } catch (error) {
        console.error("Erreur fetchClients:", error);
        if (error.response?.status === 401) {
          this.$router.push('/connexion');
        }
      }
    },
    async generateReport() {
      if (!isAuthenticatedSession()) {
         console.error("Token non trouvé, veuillez vous reconnecter.");
         return;
      }

      // Validation des dates et client sélectionné
      if (!this.selectedClient || !this.startDate || !this.endDate) {
         Swal.fire({
           icon: 'warning',
           title: 'Informations manquantes',
           text: 'Veuillez sélectionner un client et une période.',
           confirmButtonColor: 'var(--bank-navy)',
         });
         return;
      }

      // Validation des dates
      if (new Date(this.startDate) > new Date(this.endDate)) {
        Swal.fire({
          icon: 'warning',
          title: 'Période invalide',
          text: 'La date de fin doit être postérieure ou égale à la date de début.',
          confirmButtonColor: 'var(--bank-navy)',
        });
        return;
      }

      this.loading = true;
      this.reportData = [];

      try {
        const response = await axios.get(
          "/api/actions-recommandations/",
          {
            params: {
              client_login: this.selectedClient,
              start_date: this.startDate,
              end_date: this.endDate
            }
          }
        );

        // Normalisation des données reçues
        this.reportData = Array.isArray(response.data.recommandations) ? response.data.recommandations.map(item => {
          const c = item.client;
          let clientDisplay = '—';
          if (c && typeof c === 'object') {
            const name = `${c.prenom || ''} ${c.nom || ''}`.trim();
            clientDisplay = name || c.login || c.username || '—';
          }
          return {
          id: item.id,
          titre: item.titre || 'Sans titre',
          description: item.description || 'Aucune description',
          date_creation: item.date_creation,
          date_echeance: item.date_echeance || item.due_date || 'Date non spécifiée',
          statut: item.statut || item.status || 'Statut inconnu',
          clientDisplay,
          clientActions: Array.isArray(item.raci_client) ? item.raci_client.map(action => ({
            id: action.id,
            description: action.description || 'Action sans description',
            date: action.date || action.date_echeance || 'Date non spécifiée',
            statut: action.statut || action.status || 'Statut inconnu'
          })) : [],
          advisorActions: Array.isArray(item.raci_employe) ? item.raci_employe.map(action => ({
            id: action.id,
            description: action.description || 'Action sans description',
            responsible: action.responsable || action.responsible || null,
            responsable: action.responsable || action.responsible || null,
            informed: Array.isArray(action.informed) ? action.informed : [action.informed].filter(Boolean),
            accountable: action.accountable || null,
            consulted: Array.isArray(action.consulted) ? action.consulted : [action.consulted].filter(Boolean),
            date: action.date || action.date_echeance || 'Date non spécifiée',
            statut: action.statut || action.status || 'Statut inconnu'
          })) : []
        };
        }) : [];

        console.log("Report Data Normalisée:", this.reportData);

      } catch (error) {
        if (error.response?.status === 401) {
          this.errorMessage = 'Session expirée, veuillez vous reconnecter.';
          this.$router.push('/connexion');
          return;
        } else {
          this.errorMessage = error.response?.data?.detail || "Une erreur est survenue lors du chargement des statistiques.";
          Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: this.errorMessage,
            confirmButtonColor: 'var(--bank-navy)',
          });
        }
      } finally {
        this.loading = false;
      }
    },
    async exportPDF() {
      if (!isAuthenticatedSession()) {
        this.$router.push('/connexion');
        return;
      }
      if (!this.reportData?.length) {
        Swal.fire({
          icon: 'warning',
          title: 'Aucune donnée',
          text: 'Générez d\'abord un rapport.',
          confirmButtonColor: 'var(--bank-navy)',
        });
        return;
      }

      try {
        Swal.fire({
          title: 'Génération du PDF',
          text: 'Veuillez patienter...',
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const response = await axios.get('/api/mandat/reporting-pdf/', {
          params: {
            client_login: this.selectedClient,
            start_date: this.startDate,
            end_date: this.endDate,
          },
          responseType: 'blob',
          withCredentials: true,
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `reporting_client_${this.selectedClient}_${this.startDate}_${this.endDate}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        Swal.close();
        Swal.fire({
          title: 'Succès!',
          text: 'Le PDF a été téléchargé avec succès',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });
      } catch (error) {
        console.error('Erreur lors de la génération du PDF:', error);
        Swal.fire({
          title: 'Erreur!',
          text: error.response?.data?.detail || error.message || 'Une erreur est survenue lors de la génération du PDF',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      } finally {
         if (Swal.isLoading()) {
             Swal.close();
         }
      }
    },
    formatEmployeName(emp) {
      if (!emp || typeof emp !== 'object') return '—';
      const prenom = emp.prenom || '';
      const nom = emp.nom || '';
      const label = `${prenom} ${nom}`.trim();
      return label || '—';
    },
    formatDate(date) {
      if (!date || date === 'Date non spécifiée') return 'Date non spécifiée';
      try {
        // Try to parse with timezone first, then without
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        // Check if date string contains time and timezone info
        if (date.includes('T') && date.includes('Z')) {
             return new Date(date).toLocaleDateString('fr-FR', options);
        } else {
             // Assume UTC if no timezone info, to avoid local timezone issues
             const [year, month, day] = date.split('-').map(Number);
             // Use UTC method to create date object
             return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString('fr-FR', options);
        }
      } catch (e) {
         console.error("Error formatting date:", date, e);
         return 'Date invalide';
      }
    }
  }
};
</script>
<style>
.dashboard {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.cardi {
  background: var(--paper);
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.cardi .card-header {
  background: var(--brand-navy);
  color: var(--paper);
  padding: 1rem 1.25rem;
  border-bottom: none;
}

.cardi .card-header h5 {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.05rem;
  color: var(--paper);
}

.cardi .card-body {
  padding: 1.25rem;
}

.recommendation-header {
  background: rgba(10, 26, 47, 0.04);
  border: 1px solid rgba(10, 26, 47, 0.08);
  padding: 1rem 1.15rem;
}

.table-responsive {
  max-height: 400px;
  overflow-y: auto;
}

.table-sm {
  font-size: 0.875rem;
}

.table-bordered {
  border-color: var(--bank-gray-200);
}

.bg-light {
  background-color: var(--bank-gray-100) !important;
}
</style>
